





































import { computed, defineComponent } from '~/utils/nuxt3-migration'
import { ciCredit } from '~/icons/source/solid/credit'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useDep } from '~/compositions/dependency-container'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { formatNumber } from '~/utils/number'
import CPopover from '~/components/shared/configurable/CPopover.vue'

export default defineComponent({
  components: { CPopover },
  setup() {
    const legacyUrlService = useDep(LegacyUrlService)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    const paidCredits = computed(() => {
      return formatNumber(userGetters('paidCredits'))
    })

    const href = computed(() => legacyUrlService.getBuyCreditsUrl())

    return {
      ciCredit,
      paidCredits,
      href
    }
  }
})
